import React from 'react';

import s from './Preview.module.scss';

export const Preview = () => (
  <a className={s.preview} href="/api/exit-preview">
    Exit Preview
  </a>
);
